import Button from "components/Button";
import Divider from "components/Divider";
import H5 from "components/H5";
import React, { useState } from "react";
import DropdownButton from "components/Dropdown/DropdownButton";
import DropdownWrapper from "components/Dropdown/DropdownWrapper";

const Dropdown = (props) => {
  const { className, data = [], selected = 0, onChange, title } = props;
  const [activeDropdown, setActiveDropdown] = useState(false);
  console.log('selected', selected)
  const handleClick = (val, i) => {
    console.log('vas', val, i)
    onChange(val, i);
    val.onClick();
    setActiveDropdown(false);
    return true;
  };

  const isEmpty = data?.length === 0;
  return (
    <div className={`d-flex flex-row align-items-center position-relative ${className}`}>
      <Button
        typeSort
        handleRoute={() => setActiveDropdown(!activeDropdown)}
        active={activeDropdown}
      >
        <H5 color="#737980" className="margin-right-4" style={{ marginRight: "5px" }}>
          {title}
        </H5>

        {isEmpty ? "No Data" : data[selected].name}
      </Button>
      {activeDropdown && !isEmpty && (
        <DropdownWrapper left="0px" className="overflow_custom">
          {data.map((val, i) => {
            return (
              <DropdownButton
                key={val.name}
                onClick={() => handleClick(val, i)}
                active={selected === i}
              >
                <div className={`${selected === i && "fw-bold"}`}>{val.name}</div>
                <Divider
                  style={{
                    padding: 0,
                    margin: 0,
                    marginTop: 10,
                    marginBottom: 0,
                  }}
                />
              </DropdownButton>
            );
          })}
        </DropdownWrapper>
      )}
    </div>
  );
};

export default Dropdown;
